module.exports = __webpack_public_path__ + "static/media/card-toca-pintado.dc0d6be0.png";